import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  brandTitle
} = translate({
  "brandTitle": "About The Brand"
});
export const brandRedirectText = translateFormatter<{
  brand: string;
}>("Visit the {brand} store", undefined, undefined, "en");